<template>
  <div class="home">
    <div>

        <header class="blue">
            <div class="container">
				<div class="row align-items-end">
					<div class="col-sm-5">
						<h1>KLINGER Dichtungstechnik <br>material finder</h1>
						<h2>Finding KLINGER products made easy</h2>

						<!-- <div class="buttons">
							<router-link class="btn" to="/filter">Explore materials</router-link>
							<a class="btn" href="http://klinger.co.at/en/services" target="blank">Explore services</a>
						</div> -->

					</div>
					<div class="col-sm-7">
                        <div class="banner">
                            <div class="two">
                                <div class="color-1">
                                    <img src="../assets/1_HIGH_TEMPERATURE_APPLICATION.jpg" alt="">
                                    <span>HIGH TEMPERATURE APPLICATION</span>
                                </div>
                                <div class="color-2">
                                    <img src="../assets/2_PLANT_SAFETY.jpg" alt="">
                                    <span>PLANT SAFETY</span>
                                </div>
                            </div>
                            <div class="three">
                                <a target="blank" href="http://klinger.co.at/en/industries" class="color-3">
                                    <img src="../assets/3_MANUFACTURING_INDUSTRY.png" alt="">
                                    <span>MANUFACTURING INDUSTRY</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/products/ptfe-gasket-materials" class="color-4">
                                    <img src="../assets/4_PTFE_SHEETS.png" alt="">
                                    <span>PTFE SHEETS</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/industries" class="color-5">
                                    <img src="../assets/5_OIL_&_GAS.png" alt="">
                                    <span>OIL & GAS</span>
                                </a>
                            </div>
                            <div class="five">
                                <a target="blank" href="http://klinger.co.at/en/digital-services/klinger-expert" class="color-6">
                                    <img src="../assets/6_KLINGER_EXPERT.jpg" alt="">
                                    <span>KLINGER EXPERT</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/services/product-approvals" class="color-7">
                                    <img src="../assets/7_PRODUCT_APPROVALS.png" alt="">
                                    <span>PRODUCT APPROVALS</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/services/laboratories" class="color-8">
                                    <img src="../assets/8_LABORATORIES.png" alt="">
                                    <span>LABORATORIES</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/services/certification-approvals" class="color-9">
                                    <img src="../assets/9_CERTIFICATION_APPROVALS.png" alt="">
                                    <span>CERTIFICATION & APPROVALS</span>
                                </a>
                                <a target="blank" href="http://klinger.co.at/en/services/mobiles-training" class="color-10">
                                    <img src="../assets/10_MOBILE_TRAINING.png" alt="">
                                    <span>MOBILE TRAININGS</span>
                                </a>
                            </div>
                        </div>
					</div>
				</div>
            </div>
        </header>

        <section class="subheader">
            <div class="container">
                <h1>Browse KLINGER Dichtungstechnik Premium products and Unique Safety First Services</h1>
                <h2>Check Most searched KLINGER Dichtungstechnik Materials</h2>
            </div>
        </section>

        <section class="material-list">
			<div class="container">
				<ul class="row">
					<li class="col-md-3" v-for="(material, index) in favoriteMaterials" :key='index'>
						<article>
							<router-link :to="'/material/'+material.id">
							    <img :src="material.product_image" alt="">
                                <span>
                                    {{ material.title }}
                                </span>
                            </router-link>
						</article>
					</li>
				</ul>
			</div>
        </section>

        <!-- <section class="featuredButtons">
            <router-link class="btn blue" to="/filter">Explore materials</router-link>
            <a class="btn blue" href="http://klinger.co.at/en/services" target="blank">Explore services</a>
        </section> -->

        <section class="certificates">
            <div class="container">
                <div class="subheader">

                    <h2>Check Most searched KLINGER Dichtungstechnik Certificates</h2>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <img src="../assets/BAM_certificate.png" alt="">
                    </div>
                    <div class="col-md-3">
                        <img src="../assets/DIN_DVGW_certificate.jpg" alt="">
                    </div>
                    <div class="col-md-3">
                        <img src="../assets/EMAS_certificate.png" alt="">
                    </div>
                    <div class="col-md-3">
                        <img src="../assets/TUV_SUD_certificate.png" alt="">
                    </div>
                </div>
            </div>
        </section>

        <section class="popular">
            <div class="container">
                <div class="header">
                    <router-link class="btn blue" to="/filter">Go to Material finder</router-link>
                </div>
            </div>
            <a href="http://klinger.co.at/en/company/locations" target="blank" class="dealer">
                <img src="../assets/find_dealer.png" alt="">
            </a>
        </section>

    </div>
</div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import vSelect from 'vue-select'

export default {
  name: 'home',
  components: {
    vSelect
  },
  computed: {
        favoriteMaterials() {
            // We will see what `params` is shortly
            let data = Object.values(this.$root.data).filter((material) => {
                return material.favorite;
            })
            .sort((a, b) => Number(a.favorite) - Number(b.favorite))
            .slice(0,4)

            return data;
        }
    }
}
</script>

<style lang="scss">
    .home {
        h1 {
            line-height: 1.3em;
            margin-bottom: 30px;
        }
    }
    .certificates {
        padding: 5px 0 25px;
        margin-top: 35px;
        border-top: 1px solid #ebebeb;
        .row > div {
            align-items: center;
            justify-content: center;
            display: flex;
            img {
                width: 40%;
            }
        }
    }
    .dealer {
        display: block;
        text-align: center;
        background: #f0f0f0;
        margin: 0 -15px;

        img {
            display: inline;
        }
    }
    .popular {
        margin: 20px 0;
        border-top: 1px solid #ebebeb;
        padding: 30px 15px;
        // background: #d0eaff;
        h1, h2 {
            text-align: center;
            color: #3c3c3c;
        }
        .header {
            text-align: center;
            padding-bottom: 30px;
        }
    }
	.banner {
        width: 100%;
        height: 100%;
        > div {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            
            &.two {
                height: 45%;
            }

            &.three {
                height: 35%;
            }
            
            &.five {
                height: 20%;
            }

            div, a {
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                background-size: cover;
                text-align: center;
                text-shadow: 0px 2px 3px #00000091;
                position: relative;
                align-items: flex-end;
                background-color:white;
                text-decoration: none;

                &:hover {
                    img {
                        opacity: 0.8;
                    }
                }

                img {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                    z-index: 1;
                }

                span {
                    position: relative;
                    z-index: 2;
                    width: 100%;
                    background: #80808069;
                    padding: 5px;
                }

                // &.color-1 {
                //     // background-image: url(../assets/1_HIGH_TEMPERATURE_APPLICATION.jpg);
                //     background-color: #4CAF50;
                // }
                // &.color-2 {
                //     // background-image: url(../assets/2_PLANT_SAFETY.jpg);
                //     background-color: #F9A825;
                // }
                // &.color-3 {
                //     // background-image: url(../assets/3_MANUFACTURING_INDUSTRY.png);
                //     background-color: #009688;
                // }
                // &.color-4 {
                //     // background-image: url(../assets/4_PTFE_SHEETS.png);
                //     background-color: #7C4DFF;
                // }
                // &.color-5 {
                //     // background-image: url(../assets/5_OIL_&_GAS.png);
                //     background-color: #E91E63;
                // }
                // &.color-6 {
                //     // background-image: url(../assets/6_KLINGER_EXPERT.jpg);
                //     background-color: #3949AB;
                // }
                // &.color-7 {
                //     // background-image: url(../assets/7_PRODUCT_APPROVALS.png);
                //     background-color: #1DE9B6;
                // }
                // &.color-8 {
                //     // background-image: url(../assets/8_LABORATORIES.png);
                //     background-color: #607D8B;
                // }
                // &.color-9 {
                //     // background-image: url(../assets/9_CERTIFICATION_APPROVALS.png);
                //     background-color: #4CAF50;
                // }
                // &.color-10 {
                //     // background-image: url(../assets/10_MOBILE_TRAINING.png);
                //     background-color: #98a6b1;
                // }

                &:hover {
                    cursor: pointer;
                    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);
                }
            }
        }
    }
</style>
